import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import AdminApp from "@/admin/AdminApp";
import InterestFormPage from "@/pages/InterestFormPage";
import { Toaster } from "@/components/ui/sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  componentDidCatch(error) {
    console.error(error);
  }
  render() {
    if (this.state.err) {
      return (
        <div style={{ minHeight: "100vh", background: "#0B192C", color: "#F9F8F3", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontFamily: "Georgia, serif", textAlign: "center", padding: "2rem" }}>
          <h1 style={{ fontSize: "2rem", fontWeight: 300 }}>Something went adrift.</h1>
          <p style={{ opacity: 0.7, marginTop: "0.75rem" }}>Please refresh the page to return to calm waters.</p>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/interest-form" element={<InterestFormPage />} />
          <Route path="/admin" element={<AdminApp />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" richColors closeButton />
      </ErrorBoundary>
    </BrowserRouter>
  );
}
